enum ChRobinsonTranportModesEnum {
    LTL = "LTL",
    TL = "TL",
    Air = "Air",
    Ocean = "Ocean",
    Bulk = "Bulk",
    Consol = "Consol",
    Flatbed = "Flatbed",
    IMDL = "IMDL",
}

export default ChRobinsonTranportModesEnum;
